import {
  Box,
  Container,
  Heading,
  Text,
  Card,
  CardBody,
  Image,
  Link,
  Flex,
  useColorModeValue,
} from "@chakra-ui/react";

export function LandingPage() {
  const cardBg = useColorModeValue("gray.800", "gray.700");
  const cardText = useColorModeValue("gray.100", "gray.200");

  return (
    <Box
      minH="100vh"
      py={10}
      bgGradient="linear(to-br, gray.900, blue.900)"
    >
      <Container maxW="container.lg" textAlign="center">
        {/* Header */}
        <Heading
          as="h1"
          size="2xl"
          mb={4}
          className="bg-gradient-to-r from-sky-400 to-cyan-300 bg-clip-text text-transparent font-extrabold uppercase"
        >
          Nagami Games
        </Heading>
        <Text fontSize="lg" color="gray.400" mb={10}>
          Web Game Development Studio
        </Text>

        {/* Our Games Section */}
        <Heading
          as="h2"
          size="lg"
          textTransform="uppercase"
          color="cyan.300"
          mb={6}
        >
          Our Games
        </Heading>

        {/* Карточка по центру */}
        <Flex justify="center">
          <Link
            href="https://yandex.ru/games/developer/114420#app=447526"
            isExternal
            className="no-underline"
          >
            <Card
              bg={cardBg}
              shadow="lg"
              rounded="2xl"
              transition="all 0.3s ease"
              _hover={{ transform: "scale(1.05)", shadow: "xl" }}
              w="sm"
            >
              <Image
                src="/images/cover.png"
                alt="Steal A Brainrot 3D"
                borderTopRadius="2xl"
                objectFit="cover"
                maxH="200px"
              />
              <CardBody>
                <Heading
                  as="h5"
                  size="md"
                  fontWeight="bold"
                  color={cardText}
                  className="hover:text-cyan-300"
                >
                  Steal A Brainrot 3D
                </Heading>
              </CardBody>
            </Card>
          </Link>
        </Flex>
      </Container>
    </Box>
  );
}
